import buildRoute from './buildRoute'

export const getSupportTickets = async (active, ticketType) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'support-tickets',
            data: { active, ticketType },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const editSupportTicket = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'support-tickets-edit',
            data: formData,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

interface SelectionType {
    data?: []
    activate: boolean
}

export const deactivateSupportTickets = async (selection) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'support-tickets-activations',
            data: selection,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}
